import TyC from "./TyC";
export default TyC;